import React, { useState } from 'react';
import { Box, Flex, VStack, Link, Icon, Collapse, Text } from '@chakra-ui/react';
import { FaCertificate, FaUserShield, FaGlobe, FaFileAlt, FaLock, FaCog, FaQuestionCircle, FaMoneyBillWave, FaSignOutAlt } from 'react-icons/fa';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { signOutUser } from '../../utils/signout'; // Import the sign-out function

const Sidebar = ({ onSelectItem, selectedItem }) => {
  const [isPoolOpen, setIsPoolOpen] = useState(false);
  const [isDocumentOpen, setIsDocumentOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    signOutUser(); // Call the sign-out function
  };

  const togglePool = () => {
    setIsPoolOpen(!isPoolOpen);
    onSelectItem('certificatePool');
  };

  const toggleDocument = () => {
    setIsDocumentOpen(!isDocumentOpen);
    onSelectItem('documents');
  };

  const handleSelectItem = (item) => {
    if (item !== 'poolCreation') {
      setIsPoolOpen(false); // Close pool submenu when another item is selected
    }
    onSelectItem(item);
  };

  return (
    <Flex
      direction="column"
      bg="white"
      shadow="lg"
      justify="space-between"
      w="100vw"
      h="100vh"
    >
      <VStack spacing={4} align="flex-start" p={4}>
        <Box fontWeight="bold" fontSize="xl" mb={6} h="40px" display="flex" alignItems="center">
          <Text>CUROLYN Admin</Text>
        </Box>

        <Flex direction="column" as="nav" w="full">
          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'certificateSpecializationRelation' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'certificateSpecializationRelation' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('certificateSpecializationRelation')}
          >
            <Icon as={FaCertificate} mr={3} color={selectedItem === 'certificateSpecializationRelation' ? 'white' : 'black'} />
            <Text color={selectedItem === 'certificateSpecializationRelation' ? 'white' : 'black'}>Certificate Specialization Relation</Text>
          </Link>

          {/* Pool Creation with Collapse Submenu */}
          <Flex direction="column" w="full">
            <Flex
              align="center"
              p={2}
              h="40px"
              cursor="pointer"
              justifyContent="space-between"
              w="full"
              onClick={togglePool}
              bg={selectedItem === 'poolCreation' ? 'blue.500' : 'transparent'}
              _hover={{ bg: selectedItem === 'poolCreation' ? 'blue.500' : '#f0f0f0' }}
            >
              <Flex align="center" justifyContent="flex-start">
                <Icon as={FaFileAlt} mr={3} color={selectedItem === 'poolCreation' ? 'white' : 'black'} />
                <Text color={selectedItem === 'poolCreation' ? 'white' : 'black'}>Pool Creation</Text>
              </Flex>
              {isPoolOpen ? <ChevronUpIcon color={selectedItem === 'poolCreation' ? 'white' : 'black'} /> : <ChevronDownIcon color={selectedItem === 'poolCreation' ? 'white' : 'black'} />}
            </Flex>
            <Collapse in={isPoolOpen} animateOpacity>
              <Box pl={8} py={2}>
                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'certificatePool' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'certificatePool' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectItem('certificatePool')}
                >
                  <Icon as={FaCertificate} mr={3} color={selectedItem === 'certificatePool' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'certificatePool' ? 'white' : 'black'}>Certificates Pool</Text>
                </Link>

                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'authoritiesPool' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'authoritiesPool' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectItem('authoritiesPool')}
                >
                  <Icon as={FaUserShield} mr={3} color={selectedItem === 'authoritiesPool' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'authoritiesPool' ? 'white' : 'black'}>Issuing Authorities Pool</Text>
                </Link>

                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'specializationPool' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'specializationPool' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectItem('specializationPool')}
                >
                  <Icon as={FaFileAlt} mr={3} color={selectedItem === 'specializationPool' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'specializationPool' ? 'white' : 'black'}>Specialization Pool</Text>
                </Link>

                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'countriesPool' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'countriesPool' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectItem('countriesPool')}
                >
                  <Icon as={FaGlobe} mr={3} color={selectedItem === 'countriesPool' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'countriesPool' ? 'white' : 'black'}>Countries Pool</Text>
                </Link>
              </Box>
            </Collapse>
          </Flex>

          {/* Documents Dropdown */}
          <Flex direction="column" w="full">
            <Flex
              align="center"
              p={2}
              h="40px"
              cursor="pointer"
              justifyContent="space-between"
              w="full"
              onClick={toggleDocument}
              bg={selectedItem === 'documents' ? 'blue.500' : 'transparent'}
              _hover={{ bg: selectedItem === 'documents' ? 'blue.500' : '#f0f0f0' }}
            >
              <Flex align="center" justifyContent="flex-start">
                <Icon as={FaFileAlt} mr={3} color={selectedItem === 'documents' ? 'white' : 'black'} />
                <Text color={selectedItem === 'documents' ? 'white' : 'black'}>Documents</Text>
              </Flex>
              {isDocumentOpen ? <ChevronUpIcon color={selectedItem === 'documents' ? 'white' : 'black'} /> : <ChevronDownIcon color={selectedItem === 'documents' ? 'white' : 'black'} />}
            </Flex>
            <Collapse in={isDocumentOpen} animateOpacity>
              <Box pl={8} py={2}>
                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'uploadDocuments' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'uploadDocuments' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectItem('uploadDocuments')}
                >
                  <Icon as={FaFileAlt} mr={3} color={selectedItem === 'uploadDocuments' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'uploadDocuments' ? 'white' : 'black'}>Upload Documents</Text>
                </Link>

                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'viewDocuments' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'viewDocuments' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectItem('viewDocuments')}
                >
                  <Icon as={FaFileAlt} mr={3} color={selectedItem === 'viewDocuments' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'viewDocuments' ? 'white' : 'black'}>View Documents</Text>
                </Link>
              </Box>
            </Collapse>
          </Flex>

          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'subAdminCreation' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'subAdminCreation' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('subAdminCreation')}
          >
            <Icon as={FaUserShield} mr={3} color={selectedItem === 'subAdminCreation' ? 'white' : 'black'} />
            <Text color={selectedItem === 'subAdminCreation' ? 'white' : 'black'}>Sub Admin Creation</Text>
          </Link>

          {/* New Link for Certificate Manual Verification */}
          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'certificateManualVerification' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'certificateManualVerification' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('certificateManualVerification')}
          >
            <Icon as={FaCertificate} mr={3} color={selectedItem === 'certificateManualVerification' ? 'white' : 'black'} />
            <Text color={selectedItem === 'certificateManualVerification' ? 'white' : 'black'}>Certificate Manual Verification</Text>
          </Link>

          {/* New Link for Payment Tracking */}
          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'paymentTracking' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'paymentTracking' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('paymentTracking')}
          >
            <Icon as={FaMoneyBillWave} mr={3} color={selectedItem === 'paymentTracking' ? 'white' : 'black'} />
            <Text color={selectedItem === 'paymentTracking' ? 'white' : 'black'}>Payment Tracking</Text>
          </Link>
        </Flex>
      </VStack>

      <VStack spacing={4} align="flex-start" p={4} mt="auto">
        <Link
          p={2}
          h="40px"
          href="#"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          w="full"
          bg={selectedItem === 'settings' ? 'blue.500' : 'transparent'}
          _hover={{ bg: selectedItem === 'settings' ? 'blue.500' : '#f0f0f0' }}
          onClick={() => handleSelectItem('settings')}
        >
          <Icon as={FaCog} mr={3} color={selectedItem === 'settings' ? 'white' : 'black'} />
          <Text color={selectedItem === 'settings' ? 'white' : 'black'}>Settings</Text>
        </Link>
        <Link
          p={2}
          h="40px"
          href="#"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          w="full"
          bg={selectedItem === 'help' ? 'blue.500' : 'transparent'}
          _hover={{ bg: selectedItem === 'help' ? 'blue.500' : '#f0f0f0' }}
          onClick={() => handleSelectItem('help')}
        >
          <Icon as={FaQuestionCircle} mr={3} color={selectedItem === 'help' ? 'white' : 'black'} />
          <Text color={selectedItem === 'help' ? 'white' : 'black'}>Get Help</Text>
        </Link>
        <Link
          p={2}
          h="40px"
          href="#"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          w="full"
          bg="transparent"
          _hover={{ bg: '#f0f0f0' }}
          onClick={handleLogout}
        >
          <Icon as={FaSignOutAlt} mr={3} color="red.500" />
          <Text color="red.500">Logout</Text>
        </Link>
      </VStack>
    </Flex>
  );
};

export default Sidebar;